export enum chartTypes {
  area = "area",
  line = "line",
  bar = "bar",
  bubble = "bubble",
}
